import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { ProfileIcon } from '../../icons/Profile';
import { useAuth, useLoginActions } from '../../hooks/useAuth';
import { PUBLIC_URL, LANDING_PAGE_BASE_URL } from '../../config';
import { BackButtonIcon } from '../../icons/BackButton';

export const NavbarContainer = () => {
    const { authStore } = useAuth();
    const { openLogin, openMyAccount } = useLoginActions();

    return (
        <Navbar
            loggedIn={authStore.loggedIn}
            openLogin={openLogin}
            openMyAccount={openMyAccount}
        />
    );
};

export const Navbar = ({ loggedIn, openLogin, openMyAccount }) => {
    return (
        <Styled.Wrapper>
            <Styled.NavItems>
                <Styled.LeftSection>
                    <a href={LANDING_PAGE_BASE_URL}>
                        <BackButtonIcon />
                    </a>
                </Styled.LeftSection>
                <Styled.CenterSection>
                    <a href={LANDING_PAGE_BASE_URL}>
                        <Styled.Logo
                            src={`${PUBLIC_URL}/img/logos/ITV7-Master-Primary-Logo-RGB.png`}
                        />
                    </a>
                </Styled.CenterSection>
                <Styled.RightSection>
                    {loggedIn ? (
                        <Styled.LoginButton onClick={openMyAccount}>
                            <ProfileIcon />
                        </Styled.LoginButton>
                    ) : (
                        <Styled.LoginButton onClick={openLogin}>
                            <ProfileIcon />
                        </Styled.LoginButton>
                    )}
                </Styled.RightSection>
            </Styled.NavItems>
        </Styled.Wrapper>
    );
};

Navbar.propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    openLogin: PropTypes.func.isRequired,
    openMyAccount: PropTypes.func.isRequired
};

export default Navbar;
